import React from 'react';

import { Links } from '@/utils/constants';
import * as styled from './BlueBox.styled';

import { BorderLink } from '../BorderLink';
import { Button, ButtonColors } from '../Button';

interface IBlueBox {
  title: string;
  description: string;
  $hasCaption?: boolean;
}

export const BlueBox: React.FC<IBlueBox> = ({
  title,
  description,
  $hasCaption = true,
}) => (
  <styled.Box $hasCaption={$hasCaption}>
    <styled.Content>
      <styled.Title>{title}</styled.Title>
      <styled.Description>{description}</styled.Description>
      <styled.ButtonBox>
        <Button to={Links.PRICING}>Start building</Button>
        <Button to={Links.TALK} color={ButtonColors.SECONDARY}>
          Talk to experts
        </Button>
      </styled.ButtonBox>
      {$hasCaption && (
        <styled.CaptionText>
          Need a hand with development?{' '}
          <BorderLink to={Links.CONCIERGE} color="#D5EEFF">
            Concierge Services
          </BorderLink>
        </styled.CaptionText>
      )}
    </styled.Content>
    <styled.BlueBlurEllipse />
  </styled.Box>
);
